import { jsx } from "react/jsx-runtime";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { validateTidalLicense } from "../../base/index.js";
function WarningAmberOutlined(props) {
  return /* @__PURE__ */ jsx(
    WarningAmberOutlinedIcon,
    {
      "data-testid": "WarningAmberOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "WarningAmberOutlined",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
WarningAmberOutlined.tidalIconMeta = {
  categories: "cancel,informative",
  name: "WarningAmberOutlined"
};
validateTidalLicense();
export {
  WarningAmberOutlined
};
//# sourceMappingURL=WarningAmberOutlined.js.map
